/**
 * Created by kaiyan2 on 2017/1/23.
 */
import React from 'react';
import axios from 'axios'
import { generateInfoCard, generateConfigData } from "Common/utility/infoCard";


class LearningLabList extends React.Component {

    constructor(props) {
        super(props);
        this.generateItem = this.generateItem.bind(this);
        this.state = {
            items: null
        }
    }


    componentDidMount() {
        if (this.props.config) {
            this.getLabsData(this.props.config);
        }
    }

    componentDidUpdate(prevProps) {
        if (this.props.config && this.props.config != prevProps.config) {
            this.getLabsData(this.props.config);
        }
    }


    getLabsData(config) {
        if (!config.querySelector("permalink")) {
            return
        }
        const permalink = config.querySelector("permalink").innerText.trim();
        if (!permalink) {
            return
        }

        const url = PubHub.APIHost + `/v1/foundation-search/catalogs/query?type=learninglab&code_name=${permalink}&contentSubtype=module`;
        axios.get(url).then((response) => {
            this.setState({
                items: response.data.items || []
            });
        })
    }

    generateItemList(items) {
        if (!items.length) return null;

        const item = items[0];

        const subItems = (item.submodules || []).reduce((pre, cur) =>[
            ...pre,
            ...cur.items
        ], []).map(i => ({
            ...i,
            link: item.url.endsWith('/') ? item.url + i.id : item.url + '/' + i.id
        }))

        return subItems.map(this.generateItem);
    }

    generateItem(data, index) {
        const duration = data.time && (
            <div className="row pubhub-learning-lab-list-item-info">
                    <div className="col">
                        {/*<span className="pubhub-learning-lab-list-item-tags">{tags}</span>*/}
                        <span className="pubhub-learning-lab-list-item-time">{data.time} mins</span>
                    </div>
                </div>
        )
        return (
            <div key={index} className="pubhub-learning-lab-list-item">
                <div className="row pubhub-learning-lab-list-item-title">
                    <div className="col">
                        <a className='lab-list-item-link'
                        href={data.link}
                            target="_blank" 
                            data-track-name="learningLabList:lab"
                            data-track-value={data.title}  rel="noopener noreferrer">
                                <svg className='link-icon' viewBox="0 0 32 32" width="16" height="16"><path d="M26.72,24.21,20,10.76V4h1V2H11V4h1v6.76L5.28,24.21A4,4,0,0,0,8.85,30h14.3a4,4,0,0,0,3.57-5.79ZM13.89,11.45A1,1,0,0,0,14,11V4h4v7a1,1,0,0,0,.11.45L22.38,20H9.62Zm11,15.6a2,2,0,0,1-1.7.95H8.85a2,2,0,0,1-1.78-2.89L8.62,22H23.38l1.55,3.11A2,2,0,0,1,24.85,27.05Z" /></svg>
                                {data.title}
                            </a>
                    </div>
                </div>
                {duration}
            </div>
        );
    }


    render() {
        const { config, location } = this.props;
        if (!config) {
            return <span className="pubhub-loading"></span>
        }


        const data = generateConfigData(config);
        const elements = generateInfoCard(data, location || '');

        var items = <span className="pubhub-loading"></span>
        if (this.state.items) {
            items = this.generateItemList(this.state.items);
        }

        return (
            <div className="pubhub-learning-lab-list">
                <div className="container pubhub-learning-lab-list-title">
                    <div className="row">
                        <div className="col">
                            {elements.title}
                        </div>
                    </div>
                    {items}
                    <div className="row">
                        <div className="col">
                            <span data-track-name="learningLabList:viewall"
                                data-track-value={data.link.text} >
                                {elements.link}
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default LearningLabList;
